import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

export const accountSupportTicketsStyles = StyleSheet.create({
	panel: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		minHeight: 0,
	},
	header: {
		alignItems: 'center',
		borderBottom: common.border,
		display: 'flex',
		flexShrink: 0,
		gap: spacing.sm,
		justifyContent: 'space-between',
		padding: spacing.md,
	},
	title: {
		color: colors.text.dark,
		fontFamily: typography.fontFamilies.sora,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
	},
	count: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		marginLeft: spacing.xs,
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		gap: spacing.sm,
		minHeight: 0,
		overflowY: 'auto',
		padding: spacing.md,
	},
	row: {
		border: common.border,
		borderRadius: common.borderRadius,
		color: colors.text.main,
		display: 'block',
		padding: spacing.sm,
		textDecoration: 'none',
		transition: 'background-color 0.15s ease',
		':hover': {
			backgroundColor: colors.hover.light,
			textDecoration: 'none',
		},
	},
	rowTop: {
		alignItems: 'baseline',
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'space-between',
	},
	rowNumber: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	rowTime: {
		color: colors.text.light,
		flexShrink: 0,
		fontSize: typography.fontSizes.xs,
	},
	rowSubject: {
		...common.truncate,
		color: colors.text.dark,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.semibold,
		marginTop: 2,
	},
	rowContact: {
		...common.truncate,
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		marginTop: 2,
	},
	rowPills: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.xs,
		marginTop: spacing.sm,
	},
	message: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		padding: spacing.md,
		textAlign: 'center',
	},
	footer: {
		borderTop: common.border,
		display: 'flex',
		flexShrink: 0,
		padding: spacing.md,
	},
	footerLink: {
		paddingLeft: 0,
		paddingRight: 0,
	},
	/**
	 * Count badge over the drawer's 40px toolbar icon. The ring matches the toolbar rail rather than the
	 * button, whose fill flips between primary light and main as the drawer opens.
	 */
	iconBadge: {
		alignItems: 'center',
		backgroundColor: colors.danger.main,
		border: `2px solid ${colors.background.main}`,
		borderRadius: 9999,
		boxSizing: 'border-box',
		color: colors.primary.contrastText,
		display: 'flex',
		fontSize: 9,
		fontWeight: typography.fontWeights.bold,
		height: 18,
		justifyContent: 'center',
		lineHeight: 1,
		minWidth: 18,
		padding: '0 3px',
		pointerEvents: 'none',
		position: 'absolute',
		right: -3,
		top: -3,
	},
});
